import { baseApi } from './baseApi';
import { REPORT_KEYS } from '../../../views/analytics/models';

export type ReportKey = (typeof REPORT_KEYS)[keyof typeof REPORT_KEYS];

export interface ReportPage {
  name: string;
  displayName: string;
  order: number;
}

export interface EmbedToken {
  token: string;
  expiration: string;
}

export interface ReportResponse {
  id: string;
  embedToken: EmbedToken;
  embedUrl: string;
  pages: ReportPage[];
  sitesWithoutUploads?: number[];
}

export interface GetReportArgs {
  specificReport: ReportKey;
  siteId: number | string;
}

export const analyticsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getReport: builder.query<ReportResponse, GetReportArgs>({
      query: ({ specificReport, siteId }) => ({
        url: `sites/${siteId}/azure/report/v2`,
        params: { specificReport },
        global: true,
      }),
      // Embed tokens have their own expiration managed by the consumer;
      // don't let RTK Query serve a stale token after unmount.
      keepUnusedDataFor: 0,
    }),
  }),
});

export const { useGetReportQuery } = analyticsApi;
